import type { FC } from 'react';
import { Navigate, Route, Routes as RouterRoutes } from 'react-router';

import ErrorPage from './components/error/ErrorPage';
import { usePbkAuth } from './contexts/PbkAuthContext';
import { useErrors } from './global-state/Errors';
import ErrorType from './models/Error';
import ProtectedRouteWithTitle from './ProtectedRouteWithTitle';
import PublicRouteWithTitle from './PublicRouteWithTitle';
import Routes from './routes';

const { NOT_FOUND } = ErrorType;

const Router: FC = () => {
  const { isAuthenticated } = usePbkAuth();
  const errorState = useErrors((x) => x.value);

  return errorState ? (
    <ErrorPage {...errorState} />
  ) : (
    <RouterRoutes>
      {Routes.map((route) => {
        const paths = Array.isArray(route.path) ? route.path : [route.path];

        return paths.map((path) =>
          route.publicPage ? (
            <Route key={route.id} path={path} element={<PublicRouteWithTitle key={route.id} {...route} />} />
          ) : (
            <Route key={route.id} path={path} element={<ProtectedRouteWithTitle key={route.id} {...route} />} />
          ),
        );
      })}

      <>
        <Route
          index
          element={
            <ProtectedRouteWithTitle key="index" translationKey="page.clients-list" id="root" path="/" component={() => <Navigate to="/clients" />} />
          }
        />
        <Route path="*" element={<ErrorPage key="404" type={NOT_FOUND} showGoBack showContactSupport={isAuthenticated} />} />
      </>
    </RouterRoutes>
  );
};

export default Router;
